<!--关于埃文-->
<template>
  <div>
    <!--埃文简介导航图-->
    <el-row v-show="introduction_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in dataList1' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row >
    <!--首席科学家导航图-->
    <el-row v-show="scientist_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in dataList2' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--研究院简介导航图-->
    <el-row v-show="institute_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in dataList3' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--企业文化导航图-->
    <el-row v-show="enterprise_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
         <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in dataList4' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--资质荣誉导航图-->
    <el-row v-show="flair_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in dataList5' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--tabs标签页-->
    <el-row>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
      <el-col :span='16'>
        <div class='grid_content'>
          <div class='wow animate__animated animate__fadeInRight animate__slow'>
           <el-tabs v-model='activeName' @tab-click='handleClick'>
            <!--埃文简介-->
            <el-tab-pane label='埃文简介' name='avi'>
              <div class='contentArea'>
                <div class='wow animate__animated animate__fadeInRight animate__slow'>
                  <p class='ql-editor' v-html='tableData.aboutEvanContent'></p>
                </div>
              </div>
            </el-tab-pane>

            <!--首席科学家-->
            <el-tab-pane label='首席科学家' name='scientist'>
              <div  class='contentArea'>
                <div class='wow animate__animated animate__fadeInRight animate__slow'>
                  <p class='ql-editor' v-html='tableData.chiefScientistContent'></p>
                </div>
              </div>
            </el-tab-pane>
            <!--研究院简介-->
            <el-tab-pane label='研究院简介' name='researchInstitute'>
              <div  class='contentArea'>
                <div class='wow animate__animated animate__fadeInRight animate__slow'>
                 <p class='ql-editor' v-html='tableData.instituteContent'></p>
                </div>
              </div>
            </el-tab-pane>
            <!--企业文化-->
            <el-tab-pane label='企业文化' name='corporateCulture'>
              <div  class='contentArea'>
                <div class='wow animate__animated animate__fadeInRight animate__slow'>
                 <p class='ql-editor' v-html='tableData.corporateCultureContent'></p>
                </div>
              </div>
            </el-tab-pane>
            <!--资质荣誉-->
            <el-tab-pane label='资质荣誉' name='qualificationAndHonor'>
              <div  class='contentArea'>
                <div class='buts'>
                  <el-button type="primary" class='but' @click='honorPage(1)' :plain='selectA'>荣誉资质1</el-button>
                  <el-button type="primary" class='but' @click='honorPage(2)' :plain='selectB'>荣誉资质2</el-button>
                  <el-button type="primary" class='but' :plain='selectC' @click='honorPage(3)' >荣誉资质3</el-button>
                </div>
                <div class='wow animate__animated animate__fadeInRight animate__slow'>
                <!--荣誉证书-->
                <ul class='certificate'>
                  <li v-for='item in honorPageList' :key='item.value'>
                    <el-image class='imgPage'
                              :fit='fit'
                              v-if='item.imageUrl != null'
                              :src='item.imageUrl'
                    />
                  </li>
                </ul>
                </div>
<!--                <el-row>-->
<!--                  <swiper :options="swiperOption" v-if="patentList.length">-->
<!--                    <swiper-slide v-for="item of patentList" :key="item.id">-->
<!--                      <el-image class='image-slot'-->
<!--                                :fit='fit'-->
<!--                                v-if='item.imageUrl != null'-->
<!--                                :src='item.imageUrl'-->
<!--                      />-->
<!--                    </swiper-slide>-->
<!--                  </swiper>-->
<!--                </el-row>-->
              </div>
              <!--荣誉证书走马灯-->
              <div class='wow animate__animated animate__fadeInRight animate__slow'>
              <template>
                <div class='horseRaceLamp'>
                   <el-carousel :interval="4000" type="card" height="724px" >
                    <el-carousel-item v-for="item of patentList" :key="item">
                      <el-image class='imgPage1'
                                :fit='fit'
                                v-if='item.imageUrl != null'
                                :src='item.imageUrl'
                      />
                    </el-carousel-item>
                  </el-carousel>
                  </div>
              </template>
              </div>
              <div class='certificateDescription'>
                <p>依托自有的广东省省级工程技术研究中心、研究院，形成了一批拥有自主知识产权的产品和技术，目前拥有发明专利8项，软著33项</p>
              </div>
            </el-tab-pane>
          </el-tabs>
         </div>
        </div>
      </el-col>
      <el-col :span='4'>
        <div class='grid_content'></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { honorPage, selectAboutEvan, selectCarouselPicture, selectPatent } from '../../api/auth'
import 'quill/dist/quill.core.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
export default {
  // 添加组件
  components: {
    Swiper,
    SwiperSlide
  },
  created () {
    this.selectAboutEvan()
    this.selectIntroductionPicture(11)
    this.selectScientistPicture(12)
    this.selectInstitutePicture(13)
    this.selectCulturePicture(14)
    this.selectHonorPicture(15)
    this.honorPage(1)
    this.selectPatent()
  },
  mounted () {
    new this.$wow.WOW().init({// 新建实列
      boxClass: 'wow', // class名字
      animateClass: 'animate__animated', // animateclass动画库类名,和当前animate动画库决定
      offset: 0, // 到元素距离触发动画（当默认为0）
      mobile: true, // 在移动设备上触发动画（默认为true）
      live: true // 对异步加载的内容进行操作（默认为true）
    })
  },
  data () {
    return {
      swiperOption: {
        // spaceBetween: -100,
        // direction: 'horizontal', // 滑动的方向(水平方向)
        // autoplay: {
        //   delay: 1500 // 自动播放的时长
        // },
        // slidesPerView: 5, // 一屏显示的slide个数
        // centeredSlides: true, // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
        // slideToClickedSlide: true, // 点击的slide会居中
        // loop: true// 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        watchSlidesProgress: true,
        slidesPerView: 3, // 一屏显示的slide个数
        centeredSlides: true, // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
        loop: true, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        loopedSlides: 3,
        autoplay: 'horizontal', // 滑动的方向(水平方向)
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination'
        },
        on: {
          progress: function (progress) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              var slideProgress = this.slides[i].progress
              var modify = 1
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
              }
              var translate = slideProgress * modify * 260 + 'px'
              var scale = 1 - Math.abs(slideProgress) / 5
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
              slide.transform('translateX(' + translate + ') scale(' + scale + ')')
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0)
              }
            }
          },
          setTransition: function (swiper, transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      },
      honorPageParams: {
        pageNum: 1,
        pageSize: 9
      },
      selectA: false,
      selectB: true,
      selectC: true,
      queryParams: {},
      introductionParams: {
        type: 11
      },
      scientistParams: {
        type: 12
      },
      instituteParams: {
        type: 13
      },
      cultureParams: {
        type: 14
      },
      honorParams: {
        type: 15
      },
      tableData: {
        aboutEvanContent: '',
        chiefScientistContent: '',
        instituteContent: '',
        corporateCultureContent: ''
      },
      introduction_visible: true,
      scientist_visible: false,
      institute_visible: false,
      enterprise_visible: false,
      flair_visible: false,
      activeName: 'avi',
      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      dataList1: [],
      dataList2: [],
      dataList3: [],
      dataList4: [],
      dataList5: [],
      honorPageList: [],
      patentList: [],
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
    }
  },
  methods: {
    jump (raw) {
    },
    /** 公司简介滚动图  */
    selectIntroductionPicture (raw) {
      let that = this
      that.introductionParams.type = raw
      selectCarouselPicture(that.introductionParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.dataList1 = res
      })
    },
    /** 专利  */
    selectPatent () {
      let that = this
      selectPatent(that.introductionParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.patentList = res
      })
    },
    /** 首席科学家滚动图  */
    selectScientistPicture (raw) {
      let that = this
      that.scientistParams.type = raw
      selectCarouselPicture(that.scientistParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.dataList2 = res
      })
    },
    /** 研究院简介滚动图  */
    selectInstitutePicture (raw) {
      let that = this
      that.instituteParams.type = raw
      selectCarouselPicture(that.instituteParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.dataList3 = res
      })
    },
    /** 企业文化滚动图  */
    selectCulturePicture (raw) {
      let that = this
      that.cultureParams.type = raw
      selectCarouselPicture(that.cultureParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.dataList4 = res
      })
    },
    /** 资质荣誉滚动图  */
    selectHonorPicture (raw) {
      let that = this
      that.honorParams.type = raw
      selectCarouselPicture(that.honorParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.dataList5 = res
      })
    },
    handleClick (tab, event) {
      if (tab.name === 'avi') {
        this.introduction_visible = true
        this.scientist_visible = false
        this.institute_visible = false
        this.enterprise_visible = false
        this.flair_visible = false
      } else if (tab.name === 'scientist') {
        this.introduction_visible = false
        this.scientist_visible = true
        this.institute_visible = false
        this.enterprise_visible = false
        this.flair_visible = false
      } else if (tab.name === 'researchInstitute') {
        this.introduction_visible = false
        this.scientist_visible = false
        this.institute_visible = true
        this.enterprise_visible = false
        this.flair_visible = false
      } else if (tab.name === 'corporateCulture') {
        this.introduction_visible = false
        this.scientist_visible = false
        this.institute_visible = false
        this.enterprise_visible = true
        this.flair_visible = false
      } else if (tab.name === 'qualificationAndHonor') {
        this.introduction_visible = false
        this.scientist_visible = false
        this.institute_visible = false
        this.enterprise_visible = false
        this.flair_visible = true
      }
    },
    /** 资质荣誉滚动图  */
    honorPage (raw) {
      let that = this

      if (raw === 1) {
        that.selectA = false
        that.selectB = true
        that.selectC = true
      } else if (raw === 2) {
        that.selectA = true
        that.selectB = false
        that.selectC = true
      } else if (raw === 3) {
        that.selectA = true
        that.selectB = true
        that.selectC = false
      }
      that.honorPageParams.pageNum = raw
      honorPage(that.honorPageParams).then(res => {
        res.records.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.honorPageList = res.records
      })
    },
    /** 埃文简介 */
    selectAboutEvan () {
      let that = this
      selectAboutEvan(this.queryParams).then(res => {
        that.tableData.aboutEvanContent = res.aboutEvanContent
        that.tableData.chiefScientistContent = res.chiefScientistContent
        that.tableData.instituteContent = res.instituteContent
        that.tableData.corporateCultureContent = res.corporateCultureContent
      })
    }
  }
}
</script>

<style lang='less' scoped>
.block {
  .image-slot {
    width: 100%;
    height: 300px;
    margin-bottom: 40px;
  }
}
.grid_content {
  min-height: 50px;
  .contentArea{
    min-height: 600px;
    width: 100%;
    display: inline-block;
    overflow: hidden;
    border-radius: 10px;
    p{
      font-size: 16px;
      color: #000 !important;
    }
    .buts{
      width: 396px;
      margin: 20px auto;
      .but{
        border: 0;
        font-size:18px;
        font-weight: bold;
      }
    }
    //荣誉证书
    .certificate{
      display: block;
      margin:15px 0;
      li{
        width: 33.33%;
        height: 275px;
        float: left;
        .imgPage{
          width: 380px;
          height: 260px;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}
.imgPage1{
  width: 512px;
  height: 724px;
  display: block;
  margin: 0 auto;
}
//荣誉证书走马灯
.horseRaceLamp{
  width: 80%;
  height: 724px;
  margin:40px auto;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6
}
//Tabs标签页
::v-deep .el-tabs {
  display: block;
  //width:500px;
  margin: 0 auto;
}

::v-deep .el-tabs__item {
  padding: 0;
  width: 250px;
  height: 50px;
  line-height: 50px;
  font-size: 22px !important;
  font-family: "MicrosoftYaHei";
  text-align: center;
  position: relative;
}
.certificateDescription{
  text-align: center;
  margin-bottom: 30px;
  color: #000;
}
//tabs下划线
::v-deep .el-tabs__active-bar {
  background-color: #11a84e;
}

//tabs鼠标移入事件
::v-deep .el-tabs__item:hover {
  color: #11a84e;
}

//tabs鼠标点击事件
::v-deep .el-tabs__item.is-active {
  color: #11a84e;
}

</style>
